// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"21f81ae9","455":"e43d9712","977":"eb38aaa9"}[chunkId] + ".chunk.js";
};